import { ReaderModal } from "@app/components/ReaderModal.tsx";
import { fetchDocBytes } from "@app/lib/chain.ts";
import { getDocById, getNeighbours } from "@app/lib/manifest.ts";
import { navigateTo } from "@app/lib/router.ts";
import type { Manifest } from "@manifest/schema.ts";

interface Props {
  manifest: Manifest;
  docId: string;
}

export function Reader({ manifest, docId }: Props) {
  const doc = getDocById(manifest, docId);

  if (!doc) {
    return (
      <div className="p-12 text-center text-parchment-900">
        <h1 className="text-2xl font-serif mb-4">Doc not found</h1>
        <p className="text-parchment-700 mb-4">
          No doc with id <code className="font-mono bg-parchment-50 px-1 rounded">{docId}</code> in
          the manifest.
        </p>
        <button
          type="button"
          onClick={() => navigateTo({ kind: "list" })}
          className="text-parchment-800 underline decoration-parchment-400 hover:decoration-parchment-700"
        >
          Back to library
        </button>
      </div>
    );
  }

  const { prev, next } = getNeighbours(manifest, docId);

  const navProps: { onPrev?: () => void; onNext?: () => void } = {};
  if (prev) navProps.onPrev = () => navigateTo({ kind: "doc", id: prev.id });
  if (next) navProps.onNext = () => navigateTo({ kind: "doc", id: next.id });

  return (
    <ReaderModal
      doc={doc}
      prev={prev}
      next={next}
      onClose={() => navigateTo({ kind: "landing" })}
      {...navProps}
      fetchBytes={fetchDocBytes}
    />
  );
}
